<template>
    <div class="d-flex flex-row">
        <div class="mx-auto">
            <div class="cert-progress-indicator"></div>
        </div>
    </div>
</template>